import { FormControlLabel } from '@mui/material';
import React from 'react';
import * as Styled from '@innovyze/stylovyze/lib/components/FieldSwitch/FieldSwitch.styles';
import { useGlobalization } from '../../contexts';
export const ControlledSwitch = ({ label, ...switchProps }) => {
    const { t } = useGlobalization();
    return (React.createElement(Styled.SwitchContainer, null,
        React.createElement(Styled.SwitchLabel, { variant: "text-medium", color: "secondary" }, label ?? ''),
        React.createElement(FormControlLabel, { label: switchProps.checked ? t('On') : t('Off'), control: React.createElement(Styled.Switch, { ...switchProps, color: "primary" }) })));
};
